if (!customElements.get('lanmotion-slider')) {
  customElements.define('lanmotion-slider', class LanmotionSlider extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('[data-lm-slide]'));
      this.dots = Array.from(this.querySelectorAll('[data-lm-dot]'));
      this.titleOutput = this.querySelector('[data-lm-title]');
      this.bodyOutput = this.querySelector('[data-lm-body]');
      this.pagination = this.querySelector('[data-lm-pagination]');
      this.index = Math.max(0, this.slides.findIndex((slide) => slide.classList.contains('is-active')));
      this.querySelector('[data-lm-prev]')?.addEventListener('click', () => this.move(-1));
      this.querySelector('[data-lm-next]')?.addEventListener('click', () => this.move(1));
      this.dots.forEach((dot) => dot.addEventListener('click', () => this.show(Number(dot.dataset.lmIndex))));
      this.isHovered = false;
this.hasFocus = false;

this.addEventListener('mouseenter', () => {
  this.isHovered = true;
  this.stop();
});

this.addEventListener('mouseleave', () => {
  this.isHovered = false;
  this.start();
});

this.addEventListener('focusin', () => {
  this.hasFocus = true;
  this.stop();
});

this.addEventListener('focusout', (event) => {
  if (!this.contains(event.relatedTarget)) {
    this.hasFocus = false;
    this.start();
  }
});

this.handleVisibilityChange = () => {
  if (document.hidden) {
    this.stop();
  } else {
    this.start();
  }
};

document.addEventListener(
  'visibilitychange',
  this.handleVisibilityChange
);
      this.addEventListener('pointerdown', (event) => {
        if (event.button !== 0 || event.target.closest('a, button')) return;
        this.swipeStartX = event.clientX;
        this.swipePointerId = event.pointerId;
        this.setPointerCapture?.(event.pointerId);
      });
      this.addEventListener('pointerup', (event) => {
        if (this.swipeStartX == null || event.pointerId !== this.swipePointerId) return;
        const distance = event.clientX - this.swipeStartX;
        this.swipeStartX = null;
        if (this.hasPointerCapture?.(event.pointerId)) this.releasePointerCapture(event.pointerId);
        if (Math.abs(distance) > 48) this.move(distance > 0 ? -1 : 1);
      });
      this.addEventListener('pointercancel', () => { this.swipeStartX = null; });
      this.addEventListener('shopify:block:select', (event) => {
        const slide = event.target.closest('[data-lm-slide]');
        if (slide) this.show(Number(slide.dataset.lmIndex));
      });
      this.show(this.index, false);
      this.start();
    }

    disconnectedCallback() {
  this.stop();

  if (this.handleVisibilityChange) {
    document.removeEventListener(
      'visibilitychange',
      this.handleVisibilityChange
    );
  }
}

    move(direction) {
      if (this.slides.length < 2) return;
      this.show((this.index + direction + this.slides.length) % this.slides.length);
    }

    show(index, restart = true) {
      if (!this.slides.length || Number.isNaN(index)) return;
      this.index = Math.min(Math.max(index, 0), this.slides.length - 1);
      this.slides.forEach((slide, slideIndex) => {
        const active = slideIndex === this.index;
        slide.hidden = !active;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      this.dots.forEach((dot, dotIndex) => {
        if (dotIndex === this.index) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
      const activeSlide = this.slides[this.index];
      // 提前加载当前场景和下一个场景
const nextIndex = (this.index + 1) % this.slides.length;

[
  this.slides[this.index],
  this.slides[nextIndex]
].forEach((slide) => {
  const image = slide?.querySelector('img');

  if (image) {
    image.loading = 'eager';
  }
});
      const paginationSlot = activeSlide.querySelector('[data-lm-pagination-slot]');
      if (this.pagination && paginationSlot) paginationSlot.appendChild(this.pagination);
      if (this.titleOutput && activeSlide.dataset.lmTitleValue) this.titleOutput.textContent = activeSlide.dataset.lmTitleValue;
      if (this.bodyOutput && activeSlide.dataset.lmBodyValue) this.bodyOutput.textContent = activeSlide.dataset.lmBodyValue;
      if (restart) { this.stop(); this.start(); }
    }

    start() {
  // 每次启动之前，先清除上一个计时器
  this.stop();

  if (
    this.dataset.autoplay !== 'true' ||
    this.slides.length < 2 ||
    document.hidden ||
    this.isHovered ||
    this.hasFocus ||
    window.matchMedia('(prefers-reduced-motion: reduce)').matches
  ) {
    return;
  }

  const speed = Math.max(
    Number(this.dataset.speed) || 6000,
    3000
  );

  // 使用单次 setTimeout，避免多个循环计时器叠加
  this.timer = window.setTimeout(() => {
    this.timer = null;
    this.move(1);
  }, speed);
}

    stop() {
      if (this.timer) window.clearTimeout(this.timer);
      this.timer = null;
    }
  });
}
